export default __webpack_public_path__ + "static/media/invitation.55c13396.mp4";